import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CanActivate } from '@angular/router';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

@Injectable()
export class ValidarAdmin implements CanActivate {

    paramLogin: string;

    constructor(
        private msalService: MsalUserService, 
        private router: Router,
        private activeRoute: ActivatedRoute) { }

    canActivate() {
        if (environment.tipoUsuario=='Administrador') {
           
            return true;
        }
        else
      
        {
            Swal.fire({
                icon: 'error',
                title: 'Acceso Denegado...',
                text: 'Debe ser administrador para ingresar a esta opción'
              })
            return false;}
    }
}